export default __webpack_public_path__ + "static/bg-man-book-1357c118d79517dbf7bef0a6edc04bdd.jpg";